import(/* webpackMode: "eager" */ "/vercel/path0/src/app/book/page.tsx");
